import React from 'react';
import { Link } from 'react-router-dom';
import styles from './HowItWorks.module.css';

const HowItWorks = () => {
  const steps = [
    {
      id: 1,
      number: '1',
      title: 'Receive Referral',
      description: 'Your healthcare provider refers you to our home health care services for specialized care at home.'
    },
    {
      id: 2,
      number: '2',
      title: 'Assessment & Care Plan',
      description: 'Our team conducts a comprehensive visit to assess your needs and create a personalized plan of care tailored to you.'
    },
    {
      id: 3,
      number: '3',
      title: 'Begin Your Care Journey',
      description: 'Your dedicated care team provides compassionate, professional support to help you achieve your health goals at home.'
    }
  ];

  return (
    <section className={styles.howItWorksSection}>
      <div className={styles.container}>
        <div className={styles.stepsGrid}>
          {steps.map((step, index) => (
            <div key={step.id} className={styles.stepCard}>
              <div className={styles.stepNumber}>{step.number}</div>
              <h3 className={styles.stepTitle}>{step.title}</h3>
              <p className={styles.stepDescription}>{step.description}</p>
              {index < steps.length - 1 && <div className={styles.separator}></div>}
            </div>
          ))}
        </div>

        <Link to="/contact" className={styles.ctaButton}>
          Receive Referral
        </Link>
      </div>
    </section>
  );
};

export default HowItWorks;
